import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material'
import {Dispatch, SetStateAction} from 'react'

interface ConfirmNavigationDialogProps {
  handleClose: () => void
  setIsBlockActive: Dispatch<SetStateAction<boolean>>
}

export const ConfirmNavigationDialog: React.FC<ConfirmNavigationDialogProps> = ({
  handleClose,
  setIsBlockActive
}) => {
  return (
    <Dialog
      open={true}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {'Do you want to leave kiln configuration ?'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          All unsaved configuration will be lost.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          color={'error'}
          onClick={() => {
            setIsBlockActive(false)
            handleClose()
          }}
        >
          Proceed
        </Button>
        <Button onClick={handleClose}>Stay on page</Button>
      </DialogActions>
    </Dialog>
  )
}
